/* ===================================================
   HealtyCo Shopify Theme — theme.js
   =================================================== */

(function () {
  'use strict';

  // ─── SCROLL PROGRESS ───────────────────────────────────────────────
  function initScrollProgress() {
    var bar = document.getElementById('scroll-progress');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      var pct = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      bar.style.width = Math.min(100, pct) + '%';
    }, { passive: true });
  }

  // ─── STICKY HEADER — transparent at top, frosted glass on scroll ──
  function initHeader() {
    var header = document.getElementById('site-header');
    if (!header) return;
    function updateHeader() {
      if (window.scrollY > 40) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  // ─── MOBILE MENU ───────────────────────────────────────────────────
  function initMobileMenu() {
    var toggle = document.getElementById('mobile-menu-toggle');
    var menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;
    var icon = toggle.querySelector('i');
    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.toggle('open');
      if (icon) icon.className = isOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl';
    });
  }

  // ─── HERO PARALLAX ─────────────────────────────────────────────────
  function initHeroParallax() {
    var els = document.querySelectorAll('.hero-parallax, #hero-parallax');
    if (!els.length) return;
    window.addEventListener('scroll', function () {
      var ty = (window.scrollY * 0.25) + 'px';
      els.forEach(function (el) { el.style.transform = 'translateY(' + ty + ')'; });
    }, { passive: true });
  }

  // ─── CART DRAWER ───────────────────────────────────────────────────
  var cartData = { items: [], itemCount: 0 };

  function initCartDrawer() {
    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    var openBtns = document.querySelectorAll('[data-action="open-cart"]');
    var closeBtns = document.querySelectorAll('[data-action="close-cart"]');
    if (!drawer) return;

    function openCart() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      fetchCart();
    }
    function closeCart() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openCart); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeCart); });
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartData = cart;
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">' +
        '<div class="cart-empty-icon"><i class="ri-shopping-bag-3-line"></i></div>' +
        '<h3>Your cart is empty</h3>' +
        '<p>Add some wellness to your life.</p>' +
        '<a href="/collections/all" class="btn btn-dark btn-sm" onclick="document.getElementById(\'cart-drawer\').classList.remove(\'open\');document.getElementById(\'cart-overlay\').classList.remove(\'open\');document.body.style.overflow=\'\'">Start Shopping</a>' +
        '</div>';
      if (footer) footer.style.display = 'none';
    } else {
      var subtotal = cart.total_price / 100;
      var shipping = subtotal >= 75 ? 0 : 7.99;
      var freeShippingLeft = Math.max(0, 75 - subtotal);
      var pct = Math.min(100, (subtotal / 75) * 100);

      var shippingHtml = freeShippingLeft > 0
        ? '<div class="cart-shipping-bar">' +
          '<div class="cart-shipping-text"><i class="ri-truck-line" style="color:var(--color-primary)"></i>' +
          'Add $' + freeShippingLeft.toFixed(2) + ' more for <strong style="color:var(--color-primary)"> FREE Shipping</strong></div>' +
          '<div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:' + pct + '%"></div></div></div>'
        : '<div class="cart-shipping-bar"><div class="cart-free-shipping-unlocked"><i class="ri-check-double-line"></i> Free shipping unlocked!</div></div>';

      var itemsHtml = cart.items.map(function (item) {
        return '<div class="cart-item" data-key="' + item.key + '">' +
          '<img src="' + item.image + '" alt="' + item.title + '" class="cart-item-img">' +
          '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.title + '</div>' +
          '<div class="cart-item-price">$' + (item.price / 100).toFixed(2) + ' each</div>' +
          '<div class="cart-item-footer">' +
          '<div class="qty-control">' +
          '<button class="qty-btn" data-action="qty-dec" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '"><i class="ri-subtract-line"></i></button>' +
          '<span class="qty-val">' + item.quantity + '</span>' +
          '<button class="qty-btn" data-action="qty-inc" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '"><i class="ri-add-line"></i></button>' +
          '</div>' +
          '<div class="cart-item-total">' +
          '<span class="cart-item-total-price">$' + (item.line_price / 100).toFixed(2) + '</span>' +
          '<button class="cart-remove-btn" data-action="remove-item" data-key="' + item.key + '"><i class="ri-delete-bin-line"></i></button>' +
          '</div></div></div></div>';
      }).join('');

      body.innerHTML = shippingHtml + '<div class="cart-items">' + itemsHtml + '</div>';

      if (footer) {
        footer.style.display = 'block';
        footer.innerHTML =
          '<div class="cart-totals">' +
          '<div class="cart-total-row"><span>Subtotal</span><span>$' + subtotal.toFixed(2) + '</span></div>' +
          '<div class="cart-total-row"><span>Shipping</span><span>' + (shipping === 0 ? 'FREE' : '$' + shipping.toFixed(2)) + '</span></div>' +
          '<div class="cart-total-row grand"><span>Total</span><span>$' + (subtotal + shipping).toFixed(2) + '</span></div>' +
          '</div>' +
          '<a href="/cart" class="cart-checkout-btn"><span>Go to Cart</span><i class="ri-arrow-right-line"></i></a>' +
          '<div class="cart-secure"><i class="ri-secure-payment-line"></i> Secure Checkout</div>';
      }

      body.querySelectorAll('[data-action="qty-dec"], [data-action="qty-inc"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty));
        });
      });
      body.querySelectorAll('[data-action="remove-item"]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateCartItem(btn.dataset.key, 0);
        });
      });
    }
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function addToCart(variantId, qty, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetchCart();
        var overlay = document.getElementById('cart-overlay');
        var drawer = document.getElementById('cart-drawer');
        if (drawer) {
          drawer.classList.add('open');
          overlay && overlay.classList.add('open');
          document.body.style.overflow = 'hidden';
        }
        if (callback) callback();
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    document.querySelectorAll('.cart-count-text').forEach(function (el) {
      el.textContent = '(' + count + ')';
    });
  }

  // ─── QUICK ADD BUTTONS ─────────────────────────────────────────────
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="quick-add"]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.dataset.variantId;
      if (!vid) return;
      btn.classList.add('added');
      btn.innerHTML = '<i class="ri-check-line"></i> Added';
      addToCart(vid, 1, function () {
        setTimeout(function () {
          btn.classList.remove('added');
          btn.innerHTML = 'Add to Cart';
        }, 2000);
      });
    });
  }

  // ─── PRODUCT PAGE ──────────────────────────────────────────────────
  function initProductPage() {
    initGallery();
    initQtySelector();
    initAddToCart();
    initProductTabs();
    initStickyATC();
    initBoughtTogether();
  }

  function initGallery() {
    var thumbs = document.querySelectorAll('.product-thumb');
    var mainImg = document.getElementById('product-gallery-main-img');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });
  }

  function initQtySelector() {
    var decBtn = document.getElementById('qty-dec');
    var incBtn = document.getElementById('qty-inc');
    var valEl = document.getElementById('qty-val');
    var hiddenInput = document.getElementById('qty-hidden');
    if (!valEl) return;
    var qty = parseInt(valEl.textContent) || 1;
    if (decBtn) decBtn.addEventListener('click', function () {
      if (qty > 1) { qty--; valEl.textContent = qty; if (hiddenInput) hiddenInput.value = qty; updateATCPrice(qty); }
    });
    if (incBtn) incBtn.addEventListener('click', function () {
      qty++; valEl.textContent = qty; if (hiddenInput) hiddenInput.value = qty; updateATCPrice(qty);
    });
  }

  function updateATCPrice(qty) {
    var priceEl = document.getElementById('atc-price');
    var basePrice = parseFloat(priceEl && priceEl.dataset.price);
    if (priceEl && !isNaN(basePrice)) {
      priceEl.textContent = '$' + (basePrice * qty).toFixed(2);
    }
  }

  function initAddToCart() {
    var btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var vid = btn.dataset.variantId;
      var qtyEl = document.getElementById('qty-val');
      var qty = qtyEl ? parseInt(qtyEl.textContent) : 1;
      btn.classList.add('added');
      btn.innerHTML = '<i class="ri-check-line text-lg"></i> Added to Cart';
      addToCart(vid, qty, function () {
        setTimeout(function () {
          btn.classList.remove('added');
          btn.innerHTML = '<i class="ri-shopping-bag-3-line text-lg"></i> Add to Cart - ' +
            '<span id="atc-price" data-price="' + btn.dataset.price + '">$' + (parseFloat(btn.dataset.price) * (qty || 1)).toFixed(2) + '</span>';
        }, 2500);
      });
    });
  }

  function initProductTabs() {
    var tabs = document.querySelectorAll('.product-tab-btn');
    var contents = document.querySelectorAll('.product-tab-content');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        contents.forEach(function (c) { c.classList.remove('active'); });
        tab.classList.add('active');
        var target = document.getElementById('tab-' + tab.dataset.tab);
        if (target) target.classList.add('active');
      });
    });
  }

  function initStickyATC() {
    var bar = document.getElementById('sticky-atc');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) bar.classList.add('visible');
      else bar.classList.remove('visible');
    }, { passive: true });

    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var vid = stickyBtn.dataset.variantId;
        addToCart(vid, 1, function () {
          stickyBtn.textContent = 'Added!';
          setTimeout(function () { stickyBtn.textContent = stickyBtn.dataset.label; }, 2000);
        });
      });
    }
  }

  function initBoughtTogether() {
    var btItems = document.querySelectorAll('.bt-item');
    var btAddBtn = document.getElementById('bt-add-btn');
    var selected = new Set();

    btItems.forEach(function (item) {
      var vid = item.dataset.variantId;
      var checkbox = item.querySelector('.bt-checkbox');

      if (checkbox) {
        checkbox.classList.remove('checked');
        checkbox.innerHTML = '';
      }

      item.addEventListener('click', function () {
        if (selected.has(vid)) {
          selected.delete(vid);
          if (checkbox) { checkbox.classList.remove('checked'); checkbox.innerHTML = ''; }
        } else {
          selected.add(vid);
          if (checkbox) { checkbox.classList.add('checked'); checkbox.innerHTML = '<i class="ri-check-line"></i>'; }
        }
        updateBTTotal();
      });
    });

    updateBTTotal();

    if (btAddBtn) {
      btAddBtn.addEventListener('click', function () {
        if (selected.size === 0) return;
        var promises = Array.from(selected).map(function (vid) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: 1 })
          });
        });
        Promise.all(promises).then(function () {
          fetchCart();
          var drawer = document.getElementById('cart-drawer');
          var overlay = document.getElementById('cart-overlay');
          if (drawer) { drawer.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
        });
      });
    }

    function updateBTTotal() {
      if (!btAddBtn) return;
      var total = 0;
      btItems.forEach(function (item) {
        if (selected.has(item.dataset.variantId)) total += parseFloat(item.dataset.price || 0);
      });
      if (selected.size === 0) {
        btAddBtn.textContent = 'Select items to add';
      } else {
        btAddBtn.textContent = 'Add ' + selected.size + ' to Cart - $' + total.toFixed(2);
      }
      btAddBtn.disabled = selected.size === 0;
    }
  }

  // ─── TESTIMONIALS CAROUSEL ─────────────────────────────────────────
  function initTestimonials() {
    var slides = document.querySelectorAll('.testimonial-slide');
    var dots = document.querySelectorAll('.testimonial-dot');
    var prevBtn = document.querySelector('.testimonial-nav-btn.prev');
    var nextBtn = document.querySelector('.testimonial-nav-btn.next');
    if (!slides.length) return;
    var idx = 0;

    function show(i) {
      slides.forEach(function (s, j) { s.style.display = j === i ? 'block' : 'none'; });
      dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      idx = i;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { show((idx - 1 + slides.length) % slides.length); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show((idx + 1) % slides.length); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
    show(0);
  }

  // ─── FAQ ACCORDION ─────────────────────────────────────────────────
  function initFAQ() {
    document.querySelectorAll('.faq-question').forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var answer = btn.nextElementSibling;
        var toggle = btn.querySelector('.faq-toggle');
        var isOpen = answer.classList.contains('open');
        document.querySelectorAll('.faq-answer').forEach(function (a) { a.classList.remove('open'); });
        document.querySelectorAll('.faq-toggle').forEach(function (t) { t.textContent = '+'; });
        if (!isOpen) {
          answer.classList.add('open');
          if (toggle) toggle.textContent = '−';
        }
      });
    });
    var first = document.querySelector('.faq-answer');
    var firstToggle = document.querySelector('.faq-toggle');
    if (first) { first.classList.add('open'); if (firstToggle) firstToggle.textContent = '−'; }
  }

  // ─── NEWSLETTER FORM ───────────────────────────────────────────────
  function initNewsletter() {
    document.querySelectorAll('.newsletter-form-el').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('.newsletter-input');
        if (!input || !input.value.includes('@')) return;
        var success = form.parentElement.querySelector('.newsletter-success');
        form.style.display = 'none';
        if (success) success.style.display = 'flex';
        setTimeout(function () {
          form.style.display = 'flex';
          if (success) success.style.display = 'none';
          input.value = '';
        }, 4000);
      });
    });
  }

  // ─── STICKY CTA ────────────────────────────────────────────────────
  function initStickyCTA() {
    var cta = document.getElementById('sticky-cta');
    var closeBtn = document.getElementById('sticky-cta-close');
    if (!cta) return;
    var dismissed = false;
    window.addEventListener('scroll', function () {
      if (!dismissed && window.scrollY > 400) cta.classList.add('visible');
      else if (window.scrollY <= 400) cta.classList.remove('visible');
    }, { passive: true });
    if (closeBtn) closeBtn.addEventListener('click', function () {
      dismissed = true;
      cta.classList.remove('visible');
    });
  }

  // ─── COUNTDOWN TIMER ───────────────────────────────────────────────
  function initCountdown() {
    var hr = document.getElementById('countdown-hr');
    var min = document.getElementById('countdown-min');
    var sec = document.getElementById('countdown-sec');
    if (!sec) return;
    var hours = 11, minutes = 47, seconds = 32;
    setInterval(function () {
      if (seconds > 0) seconds--;
      else if (minutes > 0) { minutes--; seconds = 59; }
      else if (hours > 0) { hours--; minutes = 59; seconds = 59; }
      if (hr) hr.textContent = String(hours).padStart(2, '0');
      if (min) min.textContent = String(minutes).padStart(2, '0');
      if (sec) sec.textContent = String(seconds).padStart(2, '0');
    }, 1000);
  }

  // ─── SCROLL REVEAL (Intersection Observer) ─────────────────────────
  function initScrollReveal() {
    var els = document.querySelectorAll('.reveal-up, .reveal-scale, .reveal-left, .reveal-right, .reveal-fade, .stagger-children');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('revealed'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { observer.observe(el); });
  }

  // ─── COUNT-UP ANIMATION ────────────────────────────────────────────
  function initCountUp() {
    var counters = document.querySelectorAll('[data-count-up]');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.textContent = el.dataset.target + el.dataset.suffix; });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.dataset.target);
        var suffix = el.dataset.suffix || '';
        var duration = 2200;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var pct = Math.min((ts - start) / duration, 1);
          var val = Math.round(pct * target);
          el.textContent = val + suffix;
          if (pct < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        observer.unobserve(el);
      });
    }, { threshold: 0.2 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  // ─── COLLECTION FILTERS ────────────────────────────────────────────
  function initCollectionFilters() {
    var filterBtns = document.querySelectorAll('.filter-btn');
    var productCards = document.querySelectorAll('.filterable-card');
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.dataset.filter;
        productCards.forEach(function (card) {
          if (filter === 'all' || card.dataset.category === filter) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // ─── CONTACT FORM ──────────────────────────────────────────────────
  function initContactForm() {
    var form = document.getElementById('contact-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var submit = form.querySelector('.form-submit');
      if (submit) { submit.textContent = 'Sending...'; submit.disabled = true; }
    });
  }

  // ─── INIT ───────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    initScrollProgress();
    initHeader();
    initMobileMenu();
    initHeroParallax();
    initCartDrawer();
    initQuickAdd();
    initScrollReveal();
    initCountUp();
    initTestimonials();
    initFAQ();
    initNewsletter();
    initStickyCTA();
    initCountdown();
    initCollectionFilters();
    initContactForm();

    if (document.body.classList.contains('template-product') || document.querySelector('.product-page')) {
      initProductPage();
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

  window.ThemeCart = { addToCart: addToCart, fetchCart: fetchCart };

})();